var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgButton(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 49,
    height: 48,
    viewBox: "0 0 49 48",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M38.2698 33.1133C39.1385 32.5877 39.7192 31.634 39.7192 30.5446V20.0131C39.7192 18.3562 38.3761 17.0131 36.7192 17.0131H7.5C6.89196 17.0131 6.32617 17.194 5.8535 17.5049L4.53638 16.7009L8.0975 14.3268C8.88886 13.9311 9.54931 13.6697 10.4679 13.6697H40.939C42.9057 13.6697 44.5001 15.2641 44.5001 17.2309V29.0142C44.5001 30.0704 44.0402 31.0193 43.3098 31.6714L43.3131 31.7476L39.7193 33.9039L38.2698 33.1133Z",
    fill: "#727272"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M36.7192 17.0132H7.5C5.84315 17.0132 4.5 18.3563 4.5 20.0132V30.5447C4.5 32.2015 5.84315 33.5447 7.5 33.5447H36.7192C38.3761 33.5447 39.7192 32.2015 39.7192 30.5447V20.0132C39.7192 18.3563 38.3761 17.0132 36.7192 17.0132Z",
    stroke: "#727272",
    strokeWidth: 3,
    strokeLinecap: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgButton);
export default __webpack_public_path__ + "static/media/button.1a776210d70ec80a4a05fa8beb406790.svg";
export { ForwardRef as ReactComponent };